import React from "react";
import {
  Button,
  Tag,
  NonIdealState,
  Spinner,
  Tooltip,
  Intent,
  Toaster,
  Position,
  Dialog,
} from "@blueprintjs/core";
import { base } from "../fire";
import Classnames from "classnames";
import { getSessionFullUrl, protoString } from "../helper";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Redirect } from "react-router-dom";

import "../assets/components/Monitor.css";

import Session from "../services/Session";

import HomeMonitor from "../components/Monitor/Steps/Home";
import InterludesMonitor from "../components/Monitor/Steps/Interlude";
import SequencesMonitor from "../components/Monitor/Steps/Sequence";
import ConclusionMonitor from "../components/Monitor/Steps/Conclusion";
import FeedbacksMonitor from "../components/Monitor/Steps/Feedback";
import ParticipantsList from "../components/Monitor/ParticipantsList";

class Monitor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      session: null,
      sessionLoading: true,
      sessionInstance: null,
      sessionInstanceLoading: true,
      openParticipants: false,
      redirectHome: false,
      openRedirectResults: false,
    };
    this.userId = this.props.match.params.userId;
    this.sessionShortname = this.props.match.params.sessionShortname;
  }

  handleChangeContext = (e) => {
    const value = e.target.value;

    this.setState((prevState) => {
      prevState.session.metadata.context = value; // Create function setContext(sessionObj, context) in Session service ?

      return prevState;
    });
  };

  handleNextSequence = () => {
    if (this.isNextSequenceDisabled()) return;
    this.setState((prevState) => {
      ++prevState.sessionInstance.currentSequence;
      prevState.sessionInstance.currentSequenceResource = 0;
      return prevState;
    });
  };

  handleLastSequence = () => {
    const { session } = this.state;
    const { data } = session;
    const { sequences = [] } = data;

    if (this.isNextSequenceDisabled()) return;
    this.setState((prevState) => {
      prevState.sessionInstance.currentSequence = sequences.length - 1;
      prevState.sessionInstance.currentSequenceResource = 0;
      return prevState;
    });
  };

  handlePrevSequence = () => {
    if (this.isPrevSequenceDisabled()) return;
    this.setState((prevState) => {
      --prevState.sessionInstance.currentSequence;
      prevState.sessionInstance.currentSequenceResource = 0;
      return prevState;
    });
  };

  handleFirstSequence = () => {
    if (this.isPrevSequenceDisabled()) return;
    this.setState((prevState) => {
      prevState.sessionInstance.currentSequence = 0;
      prevState.sessionInstance.currentSequenceResource = 0;
      return prevState;
    });
  };

  handleSwitchResource = (index) =>
    this.setState({
      sessionInstance: {
        ...this.state.sessionInstance,
        currentSequenceResource: index,
      },
    });

  handleNextInterlude = () => {
    if (this.isNextInterludeDisabled()) return;
    this.setState((prevState) => {
      ++prevState.sessionInstance.currentInterlude;
      return prevState;
    });
  };

  handleNextConclusion = () => {
    if (this.isNextConclusionDisabled()) return;
    this.setState((prevState) => {
      ++prevState.sessionInstance.currentConclusion;
      return prevState;
    });
  };

  handleLastInterlude = () => {
    const { session } = this.state;
    const { data } = session;
    const { interludes = [] } = data;

    if (this.isNextInterludeDisabled()) return;
    this.setState((prevState) => {
      prevState.sessionInstance.currentInterlude = interludes.length - 1;
      return prevState;
    });
  };

  handleLastConclusion = () => {
    const { session } = this.state;
    const { data } = session;
    const { conclusions = [] } = data;

    if (this.isNextConclusionDisabled()) return;
    this.setState((prevState) => {
      prevState.sessionInstance.currentConclusion = conclusions.length - 1;
      return prevState;
    });
  };

  handlePrevInterlude = () => {
    if (this.isPrevInterludeDisabled()) return;
    this.setState((prevState) => {
      --prevState.sessionInstance.currentInterlude;
      return prevState;
    });
  };

  handlePrevConclusion = () => {
    if (this.isPrevConclusionDisabled()) return;
    this.setState((prevState) => {
      --prevState.sessionInstance.currentConclusion;
      return prevState;
    });
  };

  handleFirstInterlude = () => {
    if (this.isPrevInterludeDisabled()) return;
    this.setState((prevState) => {
      prevState.sessionInstance.currentInterlude = 0;
      return prevState;
    });
  };

  handleFirstConclusion = () => {
    if (this.isPrevConclusionDisabled()) return;
    this.setState((prevState) => {
      prevState.sessionInstance.currentConclusion = 0;
      return prevState;
    });
  };

  handleClickStep = (stepToDisplay) =>
    this.setState({
      sessionInstance: {
        ...this.state.sessionInstance,
        currentStep: stepToDisplay,
      },
    });

  isPrevInterludeDisabled = () =>
    this.state.sessionInstance.currentInterlude === 0;

  isNextInterludeDisabled = () =>
    this.state.sessionInstance.currentInterlude ===
    this.state.session.data.interludes.length - 1;

  isPrevConclusionDisabled = () =>
    this.state.sessionInstance.currentConclusion === 0;

  isNextConclusionDisabled = () =>
    this.state.sessionInstance.currentConclusion ===
    this.state.session.data.conclusions.length - 1;

  isPrevSequenceDisabled = () =>
    this.state.sessionInstance.currentSequence === 0;

  isNextSequenceDisabled = () =>
    this.state.sessionInstance.currentSequence ===
    this.state.session.data.sequences.length - 1;

  userRemainingSequence = () => {
    let sequenceDisplayed =
      this.state.session.data.sequences[
        this.state.sessionInstance.currentSequence
      ] || null;

    // Fournit une valeur par défaut pour participants pour éviter TypeError si undefined
    let participants = this.state.sessionInstance.participants || [];

    participants = participants.filter(
      (participant) => !participant.isParticipantFromPreviousSession
    );

    let results = this.state.sessionInstance.results || {};
    let participantsAmount = participants.length;

    participants.forEach((p) => {
      if (
        results[sequenceDisplayed?.id] &&
        results[sequenceDisplayed.id][p.id]
      ) {
        participantsAmount -= 1;
      }
    });

    return participantsAmount;
  };

  userRemainingFeedbacks = () => {
    let participants = this.state.sessionInstance.participants;
    let feedbacks = this.state.sessionInstance.feedbackAnswers;
    let feedBackQuestions = this.state.session.data.feedbacks;

    let participantsAmout = 0;
    if (feedbacks) {
      let feeds = Object.keys(feedbacks);
      if (participants && participants.length) {
        participants.forEach((participant, i) => {
          let participantFound = feeds.find((feed) => feed === participant.id);
          let answers = false;
          if (participantFound) {
            answers = Object.keys(feedbacks[participantFound]);
          }
          if (
            !participantFound ||
            (answers &&
              Object.keys(feedbacks[participantFound]).length <
                feedBackQuestions.length)
          ) {
            participantsAmout += 1;
          }
        });
      }
    }

    return participantsAmout;
  };

  resetCurrentParticipantsFromPilotedSession = () => {
    const { sessionInstance } = this.state;
    const { participants } = sessionInstance;
    const updatedParticipantsArray = participants.map((p) => {
      return {
        ...p,
        isParticipantFromPreviousSession: true,
      };
    });

    this.setState({
      sessionInstance: {
        ...sessionInstance,
        participants: updatedParticipantsArray,
      },
    });
  };

  render() {
    const { session, sessionLoading, sessionInstance, sessionInstanceLoading } =
      this.state;
    const { metadata } = session || { metadata: {} };
    const protocol = metadata.protocol;
    const { data } = session || { data: {} };
    const { sequences = [], interludes = [], conclusions = [] } = data;
    const { participants = [], currentStep } = sessionInstance || {};
    let sequenceDisplayed,
      interludeDisplayed,
      conclusionDisplayed = null;

    let currentSessionParticipants = participants.filter(
      (participant) => !participant.isParticipantFromPreviousSession
    );

    if (sessionLoading || sessionInstanceLoading)
      return (
        <div>
          <Spinner className="margin-top-medium" />
        </div>
      );
    if (session == null)
      return (
        <NonIdealState
          icon="cross"
          title="Session not found"
          description="The session you are looking to join does not exist."
        />
      );
    if (sessionInstance == null)
      return (
        <NonIdealState
          icon="cross"
          title="Session waiting to start"
          description="No participant has joined this session yet."
        />
      );
    if (metadata.type !== "PILOTED")
      // Use a Session Type Constant (constant/Session.js)
      return (
        <NonIdealState
          icon="lock"
          title="Autonomous session"
          description="This is a stand-alone session. The monitor is not available for this kind of session."
        />
      );
    if (this.state.redirectHome) return <Redirect to="/" />;
    sequenceDisplayed = sequences[sessionInstance.currentSequence] || null;
    interludeDisplayed = interludes[sessionInstance.currentInterlude] || null;
    conclusionDisplayed =
      conclusions[sessionInstance.currentConclusion] || null;

    return (
      <div className="monitor row animated fadeIn">
        <Toaster
          position={Position.TOP_RIGHT}
          ref={(toaster) => (this.toaster = toaster)}
        />
        <div className="col-xs-12  monitor-context">
          <button
            onClick={() => this.setState({ redirectHome: true })}
            className="d-none-comp monitor-participants"
          >
            Home
          </button>
          <div className="text-center">
            {protoString(metadata.protocol)} - {metadata.context}
          </div>
        </div>
        <div className="col-xs-12  tags">
          <Tooltip content="Click to copy the access link">
            <CopyToClipboard
              text={getSessionFullUrl(window.location, session)}
              onCopy={() =>
                this.toaster.show({
                  message: "Copied link !",
                  icon: "tick",
                  intent: Intent.PRIMARY,
                })
              }
            >
              <Tag minimal={true} round={true}>
                {getSessionFullUrl(window.location, session)}
              </Tag>
            </CopyToClipboard>
          </Tooltip>
          <Tooltip content="Name">
            <Tag minimal={true} round={true}>
              {metadata.name}
            </Tag>
          </Tooltip>
          <Tooltip content="Shortname">
            <Tag minimal={true} round={true}>
              {" "}
              {metadata.shortname}
            </Tag>
          </Tooltip>
          <Tooltip content="Protocol">
            <Tag minimal={true} round={true}>
              {protoString(metadata.protocol)}
            </Tag>
          </Tooltip>
          <Tooltip content="Number of participants">
            <Tag minimal={true} round={true}>
              {participants.length} participants
            </Tag>
          </Tooltip>
          <Button
            text="Open projection screen"
            intent={Intent.PRIMARY}
            onClick={() =>
              window.open(
                getSessionFullUrl(window.location, session),
                "",
                `channelmode=1,height=${window.screen.height},width=${window.screen.width}`
              )
            }
          />
        </div>
        <div className="col-xs-12 col-md-4">
          <div className="monitor-steps">
            <div
              onClick={() => this.handleClickStep("HOME")}
              className={Classnames({
                step: true,
                active: currentStep === "HOME",
              })}
            >
              Home
              <div className="muted d-none-mob">Display home</div>
            </div>
            <div
              onClick={() =>
                interludes.length !== 0 && this.handleClickStep("INTERLUDES")
              }
              className={Classnames({
                step: true,
                active: currentStep === "INTERLUDES",
                disable: interludes.length === 0,
              })}
            >
              Interludes
              <div className="muted d-none-mob">
                {interludes.length === 0 &&
                  "This session does not contain interludes"}
                {interludes.length !== 0 && "Display interludes"}
              </div>
            </div>
            <div
              onClick={() => this.handleClickStep("SEQUENCES")}
              className={Classnames({
                step: true,
                active: currentStep === "SEQUENCES",
              })}
            >
              Sequences
              <div className="muted d-none-mob">Display sequences</div>
            </div>
            <div
              onClick={() =>
                conclusions.length !== 0 && this.handleClickStep("CONCLUSIONS")
              }
              className={Classnames({
                step: true,
                active: currentStep === "CONCLUSIONS",
                disable: conclusions.length === 0,
              })}
            >
              Conclusions
              <div className="muted d-none-mob">
                {conclusions.length === 0 && "This session does not contain"}
                {conclusions.length !== 0 && "Display conclusions"}
              </div>
            </div>
            <div
              onClick={() => this.handleClickStep("FEEDBACKS")}
              className={Classnames({
                step: true,
                active: currentStep === "FEEDBACKS",
              })}
            >
              Feedbacks
              <div className="muted d-none-mob">Display feedbacks</div>
            </div>
            <div
              onClick={() => {
                this.setState({ openRedirectResults: true });
              }}
              className={Classnames({
                step: true,
                active: currentStep === "RESULTS",
              })}
            >
              Results
              <div className="muted d-none-mob">Display results</div>
            </div>
          </div>
        </div>
        <div className="col-xs-12 col-md-8">
          {currentStep === "HOME" && (
            <HomeMonitor participantsNumber={participants.length} />
          )}
          {currentStep === "INTERLUDES" && (
            <InterludesMonitor
              session={session}
              sessionInstance={sessionInstance}
              interludeDisplayed={interludeDisplayed}
              onPrevInterlude={this.handlePrevInterlude}
              onFirstInterlude={this.handleFirstInterlude}
              onNextInterlude={this.handleNextInterlude}
              onLastInterlude={this.handleLastInterlude}
              isNextDisabled={this.isNextInterludeDisabled}
              isPrevDisabled={this.isPrevInterludeDisabled}
            />
          )}
          {currentStep === "SEQUENCES" && (
            <SequencesMonitor
              session={session}
              sessionInstance={sessionInstance}
              sequenceDisplayed={sequenceDisplayed}
              onSwitchResource={this.handleSwitchResource}
              onPrevSequence={this.handlePrevSequence}
              onFirstSequence={this.handleFirstSequence}
              onNextSequence={this.handleNextSequence}
              onLastSequence={this.handleLastSequence}
              isNextDisabled={this.isNextSequenceDisabled}
              isPrevDisabled={this.isPrevSequenceDisabled}
              protocol={protocol}
            />
          )}
          {currentStep === "CONCLUSIONS" && (
            <ConclusionMonitor
              session={session}
              sessionInstance={sessionInstance}
              interludeDisplayed={conclusionDisplayed}
              onPrevInterlude={this.handlePrevConclusion}
              onFirstInterlude={this.handleFirstConclusion}
              onNextInterlude={this.handleNextConclusion}
              onLastInterlude={this.handleLastConclusion}
              isNextDisabled={this.isNextConclusionDisabled}
              isPrevDisabled={this.isPrevConclusionDisabled}
            />
          )}
          {currentStep === "FEEDBACKS" && (
            <FeedbacksMonitor session={session} />
          )}
        </div>
        <div className="d-none-comp">
          <Dialog
            canEscapeKeyClose={true}
            canOutsideClickClose={true}
            usePortal={true}
            isOpen={this.state.openRedirectResults}
            onClose={() => this.setState({ openRedirectResults: false })}
          >
            <div style={{ padding: "20px" }} className="text-center">
              <h3>
                Are you sure you want to leave the projection screen and go to
                results
              </h3>
              <div className="text-center">
                <Button
                  style={{ margin: "10px" }}
                  onClick={() => this.setState({ openRedirectResults: false })}
                >
                  No
                </Button>
                <Button
                  style={{ margin: "10px" }}
                  onClick={() => {
                    this.handleClickStep("RESULTS");
                    this.setState({ openRedirectResults: false });
                    setTimeout(() => {
                      this.handleClickStep("HOME");
                    }, 1500);
                  }}
                >
                  Yes
                </Button>
              </div>
            </div>
          </Dialog>
        </div>
        <div>
          {(currentStep === "SEQUENCES" || currentStep === "FEEDBACKS") && (
            <div className="monitor-participants">
              {currentStep === "SEQUENCES" && (
                <span>
                  {this.userRemainingSequence()} participant
                  {this.userRemainingSequence() > 1 ? "s" : ""} remaining out of{" "}
                  {currentSessionParticipants.length}{" "}
                </span>
              )}
              {currentStep === "FEEDBACKS" && (
                <span>
                  {this.userRemainingFeedbacks()} participant
                  {this.userRemainingFeedbacks() > 1 ? "s" : ""} out of{" "}
                  {currentSessionParticipants.length}{" "}
                </span>
              )}
            </div>
          )}
          <ParticipantsList
            session={session}
            sessionInstance={sessionInstance}
            sequenceDisplayed={sequenceDisplayed}
            feedBacks={this.state.sessionInstance.feedbackAnswers}
            removeParticipants={() =>
              this.resetCurrentParticipantsFromPilotedSession()
            }
          />
        </div>
      </div>
    );
  }

  componentWillMount() {
    const initInstanceResults = {};

    Session.getSessionByUserAndShortname(
      this.userId,
      this.sessionShortname
    ).then((session) => {
      if (session == null) return this.setState({ sessionLoading: false });
      const endpoint = `sessions/${this.userId}/${session.id}`;

      // Build the initial state of result object (only used at instance creation) of each sequence
      session.data.sequences.forEach(
        (s) => (initInstanceResults[s.id] = { _fakeId: "_fakeResult" })
      );
      this.syncSessionRef = base.syncState(endpoint, {
        context: this,
        state: "session",
        then: () => this.setState({ sessionLoading: false }),
      });
      Session.getPilotedSessionInstanceIdById(session.id)
        .then((instanceId) => {
          if (!instanceId)
            return Session.createPilotedSessionInstance(session.id, {
              created: Date.now(),
              type: "PILOTED",
              currentStep: "HOME", // Use a Session Instance constant
              currentSequence: 0,
              currentInterlude: 0,
              currentConclusion: 0,
              currentSequenceResource: 0,
              results: initInstanceResults,
              participants: [],
            }).then(() => Session.getPilotedSessionInstanceIdById(session.id));
          return instanceId;
        })
        .then((instanceId) => {
          if (!instanceId)
            return this.setState({ sessionInstanceLoading: false });
          return (this.syncSessionInstanceRef = base.syncState(
            `sessionInstances/${session.id}/${instanceId}`,
            {
              context: this,
              state: "sessionInstance",
              then: () => this.setState({ sessionInstanceLoading: false }),
            }
          ));
        });
    });
    document.body.style.background = "#232526";
    document.body.style.background =
      "-webkit-linear-gradient(to right, #232526, #414345) !important";
    document.body.style.background =
      "linear-gradient(to right, #232526, #414345) !important";
  }

  componentDidMount() {
    document.body.style.background = "#232526";
    document.body.style.background =
      "-webkit-linear-gradient(to right, #232526, #414345) !important";
    document.body.style.background =
      "linear-gradient(to right, #232526, #414345) !important";
  }

  componentWillUnmount() {
    if (this.syncSessionRef) base.removeBinding(this.syncSessionRef);
    if (this.syncSessionInstanceRef)
      base.removeBinding(this.syncSessionInstanceRef);
    document.body.style.background = null;
  }
}

export default Monitor;
